// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mediaGalleryContainer":"mediaGalleryContainer_cEO6b w-full"};